<template>
  <div class="setting-card">
    <div class="setting-card_header">
      <span class="setting-card_header_name">{{ name }}</span>
    </div>
    <div class="setting-card_content">
      <table>
        <thead>
          <tr>
            <th v-for="column in columns" :key="column">
              {{ translate('ai_settings.' + column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, key) in rows" :key="key">
            <td v-for="column in columns" :key="column">
              {{ display_value(row, column) }}
            </td>
          </tr>
          <tr v-if="!rows.length">
            <td :colspan="columns.length">{{ translate('no_data') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiSettingsItem',
  props: ['name', 'columns', 'rows'],
  methods: {
    display_value(row, column) {
      const value = row[column]
      if (value === null || value === undefined || value === '') return '—'
      if (typeof value === 'boolean') return value ? this.translate('yes') : this.translate('no')
      if (column === 'status') return this.translate('ai_settings.statuses.' + value)
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-card {
  min-width: 0;
  border-radius: 10px;
  box-shadow: 0 2px 2px #ccc5b980;
  color: #252422;
  padding-bottom: 10px;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  overflow: hidden;
  &_header {
    font: 300 14px/20px "Roboto", Arial, sans-serif;
    text-transform: uppercase;
    color: #000;
    background: #f4f3ef;
    padding: 6px 10px;
    text-align: center;
  }
  &_content {
    overflow-x: auto;
    table {
      width: 100%;
      border-collapse: collapse;
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      th, td {
        padding: 5px;
        text-align: left;
        vertical-align: top;
      }
      td {
        white-space: nowrap;
      }
      tbody tr:nth-child(2n+1) {
        background-color: #e2ecdc;
      }
    }
  }
}
</style>
